
import { defineComponent, inject, Ref } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "HelpModal",
  components: {
    CloseSVG,
  },
  setup() {

    const isPrintable = store.getters.currentLabelType === "printed" || store.getters.currentLabelType === "blank";

    const printingTips = `${window.location.origin}/printing-tips`;

    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const selectHelp = (value: string) => {
      switch (value) {
        case "guidedTour": {
          transitionToOnBoarding();
          break;
        }
        case "troubleShooting":
        case "alignmentWizard": {
          store.dispatch(ActionTypes.SET_MODAL, value);
          break;
        }
      }
    };

    const transitionToOnBoarding = () => {
      closeModal();
      store.dispatch(ActionTypes.SET_SHOW_ONBOARDING, true);
    };

    return { isPrintable, printingTips, closeModal, bounceTransition, fadeTransition, selectHelp };
  },
});
